import FormProductos from "../componentes/FormProductos.vue";
import ListaProductos from "../componentes/ListaProductos.vue";

const routes = [
    ...route("/guardar-producto-interes", FormProductos, {
        Auth: true,
        ///req_admin: true
    }),
    ...route("/lista-productos-interes", ListaProductos, {
        Auth: true,
        //req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
